<template>
  <div class="storageManeagePage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon2">
        <i class="iconfont icon-touzijihuaguanli"></i>
      </div>
      <div class="breadcrumb_item">基础设置&客服帮助</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">仓储资源管理</div>
    </div>

    <!-- 数据展示 -->
    <div class="data_show" v-if="isShow">
      <!-- 仓库列表 start -->
      <div class="state_one">
        <div class="card_list" v-if="listData.length > 0">
          <div class="card_item" v-for="item in listData" :key="item.id">
            <p>仓库名称：{{ item.whname }}</p>
            <p>货架数量：{{ item.shelfNum }}</p>
            <p>货架总层数：{{ item.shelfColumnNum }}</p>
            <p>所属企业：{{ item.qyname }}</p>
            <div class="operation flex-rowr">
              <div class="btn" @click="handlEdit(item.id)">修改仓库名称→</div>
              <div class="btn" @click="handleGo(item.id)">管理仓库→</div>
            </div>
          </div>
        </div>
        <div class="noData" v-else>您还没有设置仓库信息</div>
      </div>
      <div class="return-fixd flex-rowc">
        <div class="primary-button" @click="handleAddOne">+新增仓库</div>
        <div class="default-button" @click="handleReturn">返回</div>
      </div>

      <!-- 仓库列表 end -->
    </div>

    <!-- 数据搜索 -->
    <div class="data_add" v-else>
      <div class="add_edit">
        <div class="tit">仓库名称</div>
        <div class="input_box">
          <!-- <input type="text" v-model="name" placeholder="输入仓库名称"> -->
          <van-field
            v-model="name"
            placeholder="输入仓库名称"
            @focus="handleFocus"
            @blur="handleBlur"
          />
        </div>
        <div class="primary-button" @click="handleQuery">
          {{ isEdit ? "保存" : "确认" }}
        </div>
        <div class="primary-button return" @click="isShow = true">
          <i class="iconfont icon-yuyinjiantou"></i> 返回
        </div>
        <!-- <div class="default-button return" @click="isShow = true">←返回</div> -->
      </div>
    </div>

    <Tabbar v-if="isShowTabbar"></Tabbar>
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  getWearhouseList,
  addWearhouse,
  editWearhouse,
  encryptstringadd
} from "../../api/api";
import Tabbar from "../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "sManageIndex",
  components: {
    Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,

      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      qyid: 0,

      isShow: true,

      isEdit: false,
      listData: [],

      editId: "",
      name: "", // 仓库名称
    };
  },
   computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
    } else {
      this.qyid = 0;
    }

    this.roleId = this.$store.state.USERINFO.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.init();
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    init() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let parasm = {
        openid: this.$store.state.OPENID,
        qyid: this.qyid
      };
      getWearhouseList(parasm).then((res) => {
        if (res.length > 0) {
          let dataNew = res;
          dataNew.map((v1) => {
            // 货架数量
            v1.shelfNum = v1.childs2.length;
            v1.shelfColumnNum = 0;
            // 货架总层数
            v1.childs2.forEach((v2) => {
              v1.shelfColumnNum += v2.childs3.length;
            });
          });
          this.listData = dataNew;
        } else {
          this.listData = [];
        }
        Toast.clear();
      });
    },

    // 返回
    handleReturn() {
      history.back();
    },

    handleGo(id) {
      // this.$router.push(`/storageIndex/sManageTwo/${id}`);
      this.encryptstringadd('sManageTwo', {id})
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 新增仓库
    handleAddOne() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.name = "";
      this.isEdit = false;
      this.isShow = false;
    },
    // 编辑仓库名
    handlEdit(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      let { listData } = this;
      let filter = listData.filter((v) => v.id == id);
      this.name = filter[0].whname;
      this.editId = id;
      this.isShow = false;
      this.isEdit = true;
    },

    // 确认
    handleQuery() {
      let { name, isEdit, qyid } = this;
      if (name === "") {
        this.$toast("请输入仓库名称");
        return;
      }
      if (!isEdit) {
        let params = {
          whname: name,
          isuse: true,
          // qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addWearhouse(params).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.init();
              this.$toast.success(res.message);
              Toast.clear();
              this.isShow = true;
            }, 1000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message || "提交失败，请稍后重试！");
            setTimeout(() => {
              this.isShow = true;
            }, 2000);
          }
        });
      } else {
        let params = {
          whname: name,
          id: this.editId,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editWearhouse(params).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.$toast.success(res.message);
              this.init();
              Toast.clear();
              this.isShow = true;
            }, 1000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message || "提交失败，请稍后重试！");
            setTimeout(() => {
              this.isShow = true;
            }, 2000);
          }
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.storageManeagePage {
  padding-bottom: 350px;
  .breadcrumb {
    padding-bottom: 65px;
  }
  .noData {
    font-size: 28px;
    color: #aaaaaa;
    margin: 100px auto 0;
    text-align: center;
  }
  .data_add {
    .tit {
      font-size: 30px;
      color: #444444;
      text-align: center;
    }
    .input_box {
      margin: 38px auto 100px;
    }
  }
  .data_show {
    // min-height: 55vh;
    .state_one {
      padding: 0 75px 30px;
    }
  }
  .card_item {
    background: #f6f6f6;
    border-radius: 30px;
    padding: 50px 20px 20px 50px;
    box-sizing: border-box;
    margin-bottom: 50px;
    p {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 15px;
      line-height: 30px;
    }
    .operation {
      margin-top: 30px;
      .btn {
        font-size: 20px;
        color: #fff;
        height: 50px;
        line-height: 50px;
        background: #6e5c86;
        border-radius: 25px;
        padding: 0 30px;
        &:last-child {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>